import { render, staticRenderFns } from "./DurationChart.vue?vue&type=template&id=3d2a2266"
import script from "./DurationChart.vue?vue&type=script&lang=js"
export * from "./DurationChart.vue?vue&type=script&lang=js"
import style0 from "./DurationChart.vue?vue&type=style&index=0&id=3d2a2266&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports